import { ReactNode } from "react";
import Styles from './NSSection.module.css'
import { IBaseComponentProps } from "../props/IBaseComponentProps";

export interface NSSectionProps extends IBaseComponentProps
{
	children: ReactNode;
	onEnterPressed?: () => void;
}

export function NSSection(props: NSSectionProps)
{
	return (
		<section
			id={props.id}
			className={`container d-flex flex-wrap justify-content-center ${Styles.ns_section} ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
			onKeyUp={e =>
			{
				if (e.key === "Enter")
					props.onEnterPressed?.();
			}}
		>
			{props.children}
		</section>
	);
}